import { Uuid } from "../../domain/model/uuid/uuid.type";
import { AnimalWeightsViewModel } from "./animal-weights.viewmodel";
import { UpdateInfoViewModel } from "./update.viewmodel";

export class AnimalWeighingSaveInfoViewModel {

  constructor(
    readonly id: Uuid,
    readonly batchWeighingId: Uuid,
    readonly animalWeights: AnimalWeightsViewModel,
    readonly updateInfo: UpdateInfoViewModel) { }
}
